import { useEffect, useState } from 'react';


function tripleEquals<T>(a: T, b: T) {
    return a === b;
}

export const useInternalValue = <T>(
    externalValue: T,
) => {
    const [internalValue, setInternalValue] = useState<T>(externalValue);

    useEffect(() => {
        if (!tripleEquals(externalValue, internalValue)) {
            setInternalValue(externalValue);
        }
    }, [externalValue, tripleEquals]);

    return [internalValue, setInternalValue] as const;
};